import * as Sentry from '@sentry/react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { BaseLayout } from 'src/components/layouts/BaseLayout'
import { GlobalProductStateProvider } from 'src/components/providers/GlobalProductProvider'
import { LoginRequiredProvider } from 'src/components/providers/LoginRequiredProvider'
import { ScrollReset } from 'src/components/ScrollReset'
import { CompletePage } from 'src/pages/auth/CompletePage'
import { LoginPage } from 'src/pages/auth/LoginPage'
import { BasicRouterPage } from 'src/pages/BasicRouterPage'
import { ClientPage } from 'src/pages/Client'
import { ClientDevice } from 'src/pages/ClientDevice'
import { ClientDevices } from 'src/pages/ClientDevices'
import { ClientInquiriesPage } from 'src/pages/ClientInquiriesPage'
import { ClientInquiryPage } from 'src/pages/ClientInquiryPage'
import { ClientSubGroupPage } from 'src/pages/ClientSubGroup'
import { ClientSubGroups } from 'src/pages/ClientSubGroups'
import { Clients } from 'src/pages/Clients'
import { DeviceBuybackPage } from 'src/pages/DeviceBuyback'
import { DeviceBuybackNewPage } from 'src/pages/DeviceBuybackNew'
import { DeviceBuybacksPage } from 'src/pages/DeviceBuybacks'
import { DeviceProductPage } from 'src/pages/DeviceProductPage'
import { NotFound } from 'src/pages/error/NotFound'
import { Catalog } from 'src/pages/fixed/Catalog'
import { Tokai0001 } from 'src/pages/fixed/deviceTypes/Tokai0001'
import { Flyer } from 'src/pages/fixed/Flyer'
import { Inquiry } from 'src/pages/fixed/Inquiry'
import { InquiryRegister } from 'src/pages/fixed/Inquiry/InquiryRegister'
import { InquiryRegisterWithCode } from 'src/pages/fixed/Inquiry/InquiryRegisterWithCode'
import { Poster } from 'src/pages/fixed/Poster'
import { HelpPage } from 'src/pages/HelpPage'
import { HelpContentPage } from 'src/pages/HelpPage/contents'
import { LP } from 'src/pages/LP'
import { NewsDetailPage } from 'src/pages/NewsDetailPage'
import { NewsPage } from 'src/pages/NewsPage'
import { NotificationPage } from 'src/pages/Notification'
import { NotificationsPage } from 'src/pages/Notifications'
import { ProfileSettingPage } from 'src/pages/ProfileSettingPage'
import { TermsOfUse } from 'src/pages/public/TermsOfUse'
import { TokuteishouTorihikihou } from 'src/pages/public/TokuteishouTorihikihou'
import { RegisterClientDevice } from 'src/pages/RegisterClientDevice'
import { AnonymousOnlyProvider } from '../providers/AnonymousOnlyProvider'
import { BaseProvider } from '../providers/BaseProvider'
import { ClientProvider } from '../providers/ClientProvider'

const SentryRoutes = Sentry.withSentryReactRouterV7Routing(Routes)

export const RouteConfig = () => {
  return (
    <BrowserRouter>
      <SentryRoutes>
        {/* <Suspense> */}
        <Route path="/" element={<BaseProvider />}>
          <Route path="/" element={<ClientProvider />}>
            <Route path="/" element={<BaseLayout />}>
              <Route path="/" element={<BasicRouterPage />} />
              <Route path="/" element={<LoginRequiredProvider />}>
                <Route path="/" element={<GlobalProductStateProvider />}>
                  <Route path="/devices/register/:id" element={<RegisterClientDevice />} />
                  {/* clients */}
                  <Route path="/clients" element={<Clients />} />
                  {/* ここは :clientIdにしない */}
                  <Route path="/clients/:id" element={<ClientPage />} />
                  <Route path="/clients/:clientId/devices" element={<ClientDevices />} />
                  <Route path="/clients/:clientId/devices/register/:id" element={<RegisterClientDevice />} />
                  <Route path="/clients/:clientId/devices/:id" element={<ClientDevice />} />
                  <Route path="/clients/:clientId/subGroups" element={<ClientSubGroups />} />
                  <Route path="/clients/:clientId/subGroups/:id" element={<ClientSubGroupPage />} />
                  <Route path="/clients/:clientId/notifications" element={<NotificationsPage />} />
                  <Route path="/clients/:clientId/notifications/:id" element={<NotificationPage />} />
                  <Route path="/clients/:clientId/inquiries" element={<ClientInquiriesPage />} />
                  <Route path="/clients/:clientId/inquiries/:id" element={<ClientInquiryPage />} />
                  <Route path="/clients/:clientId/orders" element={<DeviceProductPage />} />
                  {/* 買取。docs/specs/device-buyback.md */}
                  <Route path="/clients/:clientId/buybacks" element={<DeviceBuybacksPage />} />
                  <Route path="/clients/:clientId/buybacks/new" element={<DeviceBuybackNewPage />} />
                  <Route path="/clients/:clientId/buybacks/:id" element={<DeviceBuybackPage />} />
                  <Route path="/clients/:clientId/profile" element={<ProfileSettingPage />} />
                </Route>
              </Route>
              <Route path="/" element={<AnonymousOnlyProvider />}>
                <Route path="/auth/login" element={<LoginPage />} />
                <Route path="/auth/complete" element={<CompletePage />} />
              </Route>
              <Route path="/deviceTypes/lte-model-0001" element={<Tokai0001 />} />
              <Route path="/catalog" element={<Catalog />} />
              <Route path="/flyer" element={<Flyer />} />
              <Route path="/poster" element={<Poster />} />
              <Route path="/inquiry/register" element={<InquiryRegister />} />
              <Route path="/invitation" element={<InquiryRegisterWithCode />} />
              <Route path="/inquiry" element={<Inquiry />} />
              <Route path="/public/termsOfUse" element={<TermsOfUse />} />
              <Route path="/public/tokuteishoutorihikihou" element={<TokuteishouTorihikihou />} />
              <Route path="/lp" element={<LP />} />
              <Route path="/help" element={<HelpPage />} />
              <Route path="/help/:id" element={<HelpContentPage />} />
              <Route path="/news" element={<NewsPage />} />
              <Route path="/news/:id" element={<NewsDetailPage />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Route>
        </Route>
        {/* </Suspense> */}
      </SentryRoutes>
      <ScrollReset />
    </BrowserRouter>
  )
}
